import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PpbDashboardComponent } from './ppb-dashboard.component';
import { OverlayModule } from '@psei/ng/overlay';



@NgModule({
  declarations: [PpbDashboardComponent],
    imports: [
        CommonModule,
        OverlayModule
    ]
})
export class PpbDashboardModule { }
